import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const Header = styled.header`
  margin-bottom: 0 !important;
`;

export const LinkButton = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 16px;
  font-family: 'Museo';
  color: #3D3D3D;
  text-decoration: none;
  font-family: "Museo";

  &:hover {
    text-decoration: none;
  }
`;

export const Button = styled.span`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    transform: rotate(-90deg) translateY(-1px);
    font-size: 1em;
  }
`;
